import { DataValidationError } from "constants/DataValidationError";
import { IsDate, IsNotEmpty, IsNumber, IsString } from "class-validator";
import JournalType from "../../enum/JournalType";
import { Type } from "class-transformer";

export default class UpdateJournalReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsNumber()
  journalId!: number;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsNumber()
  shopId!: number;

  @Type(() => Date)
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsDate()
  date!: Date;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  type!: JournalType;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsString()
  genre!: string;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsString()
  itemName!: string;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsNumber()
  amount!: number;

  constructor(arg: any) {
    arg = arg || {};
    this.journalId = arg.journalId;
    this.shopId = arg.shopId;
    this.date = arg.date;
    this.type = arg.type;
    this.genre = arg.genre;
    this.itemName = arg.itemName;
    this.amount = arg.amount;
  }
}
